import Image from 'next/image';
import { Check } from 'lucide-react';

export type CardExclusiveOfferProps = {
  image?: string;
  title: string;
  subtitle: string;
  benefits: string[];
  ctaText: string;
  ctaHref: string;
  discountLabel?: string;
  children?: React.ReactNode;
};

export const ExclusiveOffer = ({ image, title, subtitle, benefits, ctaText, ctaHref, discountLabel, children }: CardExclusiveOfferProps) => {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gray-100 p-6">
      {discountLabel && (
        <div className="absolute right-0 top-6 z-10 rounded-l-lg bg-error px-4 py-2">
          <span className="text-sm font-bold text-white">{discountLabel}</span>
        </div>
      )}

      {image && (
        <div className="mb-4 flex justify-start">
          <Image src={image} alt={title} width={125} height={60} className="object-contain" />
        </div>
      )}

      <h3 className="mb-2 text-lg font-bold">{title}</h3>
      <p className="mb-4 text-sm text-gray-600">{subtitle}</p>

      <div className="mb-6 space-y-2">
        {benefits.map((benefit, index) => (
          <div key={index} className="flex items-start gap-2">
            <Check className="mt-0.5 h-4 w-4 flex-shrink-0 text-green-500" />
            <span className="text-xs text-gray-700">{benefit}</span>
          </div>
        ))}
      </div>

      <a
        href={ctaHref}
        target="_blank"
        className="inline-flex items-center text-sm font-medium text-primary hover:text-primary-darker"
        rel="noreferrer"
      >
        {ctaText} →
      </a>
      {children}
    </div>
  );
};
